// tutorial: traduzioni delle stringhe della funzione di traduzione $t
// traduzione dei messaggi d'errore di vee-validate
const es = {
    'countryCode': 'es_es',
    'Accetto il regolamento fidelity e la privacy policy': 'Acepto el reglamento de fidelidad y la política de privacidad',
    'Account creation': 'Creación de cuenta',
    'Add address': 'Añadir dirección',
    'Address': 'Dirección',
    'Address label': 'Nombre dirección',
    'Address label placeholder': 'por ejemplo: casa, trabajo...',
    'Amount': 'Importe',
    'Apply': 'Aplicar',
    'Apply Discount': 'Aplicar descuento',
    'Are you sure you want to delete this item from cart': '¿Seguro que deseas eliminar este artículo del carrito?',
    'Are you sure you want to move this item to wishlist?': '¿Seguro que quieres mover este artículo a la lista de deseos?',
    'articles': 'artículos',
    'articles inside': 'artículos presentes',
    'Back': 'Atrás',
    'Back to cart': 'Volver al carrito',
    'Back to shopping': 'Seguir comprando',
    'Back to store': 'De vuelta a la tienda',
    'Billing address': 'Dirección de facturación',
    'Billing address is the same as the shipping address': 'Los datos de facturación y envío son los mismos',
    'Buy': 'Comprar',
    'Buy Now': 'Comprar ahora',
    'Buy now, pay later': 'Compre ahora, pague luego',
    'Cancel': 'Cancelar',
    'Cannot apply Gift Card': 'No se puede aplicar tarjeta regalo',
    'Cannot apply glam card points': 'No ha sido posible aplicar los puntos de tu tarjeta WE',
    'Card issuer authentication failed': 'La autentificación del emisor de la tarjeta ha fallado',
    'Cart': 'Carrito',
    'Cart content': 'Contenido del carrito',
    'Change': 'cambiar',
    'Change address': 'Cambiar dirección',
    'Change e-mail': 'Cambiar correo electrónico',
    'Change pickup point': 'Cambiar punto de recogida',
    'Check zip code': 'Compruebe el código postal',
    'Choose a shipping method in order to proceed': 'Para continuar selecciona el método de envío',
    'Choose a store for the pick-up in order to proceed': 'Elija una tienda para la recogida a fin de proceder ',
    'Choose a zipcode in order to proceed': 'Elija un código postal a fin de proceder',
    'City': 'Ciudad',
    'Close': 'Cerrar',
    'Closed': 'Cerrado',
    'Color': 'Color',
    'Complete your order': 'Finalizar el pedido',
    'Condizioni di vendita': 'Condiciones de venta',
    'Confirm': 'Confirmar',
    'Continue': 'Continuar',
    'Continue as guest': 'Continuar como invitado',
    'Country': 'País',
    'Coupon': 'Cupón',
    'Coupon Code': 'Código de descuento',
    'Credit Card': 'Tarjeta de crédito',
    'Credit Card Number': 'Número de la tarjeta',
    'data': 'datos',
    'Date of birth': 'Fecha de nacimiento',
    'Date of Birth': 'Fecha de nacimiento',
    'dd/mm/yyyy': 'dd/mm/aaaa',
    'Delete': 'Eliminar',
    'Delivery:': 'Entrega:',
    'Description': 'Descripción',
    'Do you have a discount code?': '¿Tienes un código de descuento?',
    'Enter your Gift Card here': 'Inserta aquí la tarjeta regalo',
    'do-login': 'Iniciar sesión',
    'done': 'hecho',
    'E-mail address': 'Correo electrónico',
    'Edit': 'Modificar',
    'Edit address': 'Editar dirección',
    'Edit Cart': 'Modificar carrito',
    'Email': 'Correo electrónico',
    'Email and telephone number': 'Correo electrónico y número de teléfono',
    'email-remainder': 'Te hemos enviado un correo electrónico para restablecer la contraseña. Haz clic en el enlace que encontrarás en su interior.',
    'Empty credit card fields': 'Debes rellenar los datos de la tarjeta de crédito',
    'Enter shipping address': 'Ingrese la dirección de envío',
    'Enter the points to be used here': 'Ingresa aquí los puntos a utilizar',
    'Error during payment authorization': 'Ha habido un error durante la autorización del pago',
    'Error during registration': 'Error durante el registro',
    'Error occurred while placing orde': 'Ha habido un error mientras se hacía el pedido',
    'Expire Date': 'Caducidad',
    'Female': 'Mujer',
    'Firstname': 'Nombre',
    'Forgot your password?': '¿Has olvidado la contraseña?',
    'Free': 'Gratuito',
    'Friday': 'viernes',
    'From': 'Desde',
    'Gender': 'Sexo',
    'Gift Card': 'Tarjeta de regalo',
    'Gift card and discount codes': 'Tarjeta regalo y códigos de descuento',
    'giftcardmsg': 'Giftcard {code}',
    'Glam card discount': 'Descuento bonus tarjeta WE',
    'glamcard-bonusapplied': 'Aplicados {bonus} puntos de tu tarjeta WE',
    'Go to checkout': 'Ir a la caja',
    'Go to payment': 'Proceder al pago',
    'Go to shipping': 'Ir a envío',
    'Go to summary': 'Ir al resumen',
    'Home delivery cost': 'Coste de entrega en casa',
    'How many points do you want to use?': '¿Cuántos puntos quieres usar?',
    'How much bonus do you want to use?': '¿Cuántos puntos quiere usar?',
    'I don\'t want to receive the invoice': 'No quiero recibir la factura',
    'I tuoi contatti telefonici possono servirci per contattarti in caso di domande. Il tuo contatto cellulare ci dà la possibilità di inviarti un SMS gratuito per avvisarti della consegna della merce.': 'Tus contactos telefónicos pueden servirnos para ponernos en contacto contigo en caso de preguntas. Tu contacto móvil nos da la posibilidad de enviarte un SMS gratuito para avisarte de la entrega de la mercancía.',
    'I want to receive the invoice': 'Quiero recibir la factura',
    'Identical to shipping address': 'Idéntica a la dirección de envío',
    'Insert here coupon code': 'Introduce aquí el código de descuento',
    'Insert here the shipping data': 'Introduce aquí los datos de envío',
    'Insert here your email to proceed, we will send you just the order updates': 'Introduce tu correo electrónico para proceder, solamente te enviaremos la información relacionada con este pedido',
    'Insert your billing address': 'Insertar la dirección de facturación',
    'invoice': 'factura',
    'Invoice address': 'Dirección de la factura',
    'Last name': 'Apellidos',
    'Lastname': 'Apellidos',
    'Leave': 'Salir',
    'Loading': 'Cargando',
    'Loading payment form, please wait': 'Cargando el formulario de pago, espere, por favor',
    'login': 'Usuario',
    'Login': 'Usuario',
    'Male': 'Hombre',
    'Message': 'Mensaje',
    'Mobile phone': 'Número de teléfono',
    'Monday': 'lunes',
    'Move item': 'Pasar artículo',
    'Move product': 'Mover producto',
    'Name': 'Nombre',
    'New address': 'Nueva dirección',
    'New client': 'Nuevo cliente',
    'No items in cart': 'El carrito está vacío',
    'No near stores': 'No hay tiendas cercanas',
    'No shipping methods available': 'No hay ningún método de envío disponible',
    'Not registered yet?': '¿Aún no te has registrado?',
    'Ok': 'Aceptar',
    'Or': 'O',
    'Order detail': 'Detalle de la orden',
    'Order details': 'Detalles del pedido',
    'Order placed': 'Pedido realizado. Vamos a redirigirte a la página del resumen',
    'Order will be shipped to': 'El pedido se enviará a',
    'Password': 'Contraseña',
    'Password confirm': 'Confirma la contraseña',
    'Pay': 'Pagar',
    'payment': 'Pago',
    'Payment': 'Pago',
    'Payment error.': 'Error de pago.',
    'Payment method': 'Método de pago',
    'Payment method not supported': 'El método de pago no está disponible',
    'Personal data': 'Datos personales',
    'Place of birth': 'Lugar de nacimiento',
    'Place of Birth': 'Lugar de nacimiento',
    'Please select shipping from Amazon widget': 'Por favor, seleccione un envío desde un widget de Amazon',
    'Please try again with another form of payment': 'Vuelva a intentarlo con otra forma de pago',
    'Please wait': 'Por favor, espera',
    'Please wait, payment is processing': 'Por favor, espere, el pago se está procesando',
    'Postcode': 'Código postal',
    'Prefix': 'Prefijo',
    'Proceed': 'Procede',
    'Proceed delete': 'Proceder',
    'Proceed to payment': 'Procede al pago',
    'Proceed with the purchase': 'Proceder con la compra',
    'product': 'producto',
    'Product': 'Producto',
    'products': 'productos',
    'Products total': 'Total de productos',
    'Quantity': 'Cantidad',
    'Register': 'Registrate',
    'Registered User': 'Usuario registrado',
    'Registration agreement': 'Acuerdo de inscripción',
    'Registration successful': 'Registro exitoso',
    'registrationagreement': 'Accepto el <a href="{linkfid}" target="_blank">reglamento de fidelidad</a> y la <a href="{linkpriv}" target="_blank">política de privacidad</a>',
    'Remove': 'Retirar',
    'Remove Discount': 'Eliminar descuento',
    'Remove the item': 'Eliminar artículo',
    'Required fields': 'Campos requeridos',
    'Retry': 'Vuelva a intentarlo',
    'review': 'resumen',
    'Safe purchase': 'Compra segura',
    'Same as billing': 'La misma que la dirección de facturación',
    'Saturday': 'sábado',
    'Save': 'Guardar',
    'Save address': 'Guardar dirección',
    'Save in address book': 'Guardar en la libreta de direcciones',
    'Save new address to proceed': 'Guarde la nueva dirección para continuar',
    'Select': 'Seleccionar',
    'Select a city': 'Selecciona la ciudad',
    'Select a payment method': 'Selecciona un método de pago',
    'Select a region': 'Selecciona la región',
    'Select an address': 'Seleccione una dirección',
    'Select here your shipping address': 'Selecciona aquí tu dirección de envío',
    'Select payment method': 'Selecciona un método de pago',
    'Select region': 'Selecciona la provincia',
    'Select shipping method': 'Selecciona un método de envío',
    'Select store pickup': 'Seleccionar recogida en tienda',
    'Select store pickup to procede': 'Seleccione una recogida en tienda para proceder ',
    'Select the store': 'Selecciona la tienda',
    'Select this store': 'Seleccionar esta tienda',
    'Select value': 'Selecciona un valor',
    'Selected Store': 'Tienda seleccionada',
    'Seleziona il metodo di spedizione': 'Selecciona el método de envío',
    'Send remainder': 'Enviar correo electrónico de recuperación de la contraseña',
    'Service unavailable, retry later': 'Servicio no disponible, inténtalo de nuevo más tarde',
    'Session expired, page will reload': 'La sesión ha expirado, la página se volverá a cargar',
    'shipping': 'Envío',
    'Shipping': 'Envío',
    'Shipping address': 'Dirección de envío',
    'Shipping and handling': 'Envío y gestión',
    'Shipping data': 'Fecha de envío',
    'Shipping informations': 'Datos de envío',
    'Shop opening hours': 'Horarios de apertura comercial',
    'Shopping Cart': 'Carrito',
    'shopping details': 'detalles de la compra',
    'Size': 'Talla',
    'Something went wrong during Yandex Checkout': 'Algo ha ido mal durante el proceso de compra en línea Yandex',
    'State/Region': 'Provincia',
    'Store selection': 'Selección de tienda',
    'street': 'calle',
    'Street': 'Calle',
    'Street number': 'Número',
    'Sunday': 'domingo',
    'Surname': 'Apellidos',
    'Tax included': 'Impuestos incluidos',
    'Telephone': 'Teléfono',
    'Telephone number for courier / store pickup': 'Número de teléfono para mensajería/recogida en tienda',
    'Terranova stores near you': 'Tiendas Terranova cerca de ti',
    'The coupon code isn\'t valid. Verify the code and try again.': 'El cupón no es válido. Comprueba el código e inténtalo de nuevo.',
    'The gift card is invalid or empty. Please check the gift card and try again': 'La tarjeta regalo no es válida o está vacía. Compruebe la tarjeta regalo y vuelva a intentarlo',
    'The maximum value of the usable We+Card bonus is': 'El valor máximo de la tarjeta bonus WE utilizable es',
    'The maximum value of the usable WE+Card points is': 'El valor máximo de los puntos WE Card disponibles es',
    'The order is already been paid, please wait while order is placing': 'El pedido ya se ha abonado, espere mientras se gestiona el pedido',
    'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).': 'La contraseña debe tener al menos 8 caracteres y una letra mayúscula, una minúscula, un número y un carácter especial (.;,!$#).',
    'The requested qty is not available': 'La cantidad solicitada no está disponible',
    'There has been an error. Please try again': 'Ha habido un error. Vuelva a intentarlo',
    'This email already esists. Do the login or proceed as guest': 'Este correo electrónico ya existe. Inicia sesión o continúa como invitado',
    'This product is not available, please remove it from cart to proceed': 'Este producto no está disponible; retíralo del carrito para proceder',
    'Thursday': 'jueves',
    'To': 'Hasta',
    'Total': 'Total',
    'Tuesday': 'martes',
    'Type of card': 'Tipo de tarjeta',
    'Update address': 'Actualizar dirección',
    'Use Glam Card Bonus': 'Usar la tarjeta Bonus WE',
    'Use points': 'Usar puntos',
    'Use WE+ points': 'Usar puntos WE Card',
    'User': 'Usuario',
    'Valid until': 'caduca el',
    'VAT number': 'Número de IVA',
    'Verify billing address': 'Compruebe la dirección de facturación',
    'Verify Gift Card': 'Verificar tarjeta de regalo',
    'Verify payment method selection': 'Compruebe la selección del método de pago',
    'Verify shipping address': 'Compruebe la dirección de envío',
    'Verify shipping method selection': 'Compruebe la selección del método de envío',
    'View your cart': 'Ver su cesta',
    'Wait for page to reload': 'Espere a que la página se vuelva a cargar',
    'We\'re unable to send the password reset email': 'No ha sido posible enviar el correo electrónico para restablecer la contraseña. Comprueba el correo electrónico introducido',
    'Wednesday': 'miércoles',
    'You are ordering with this email address': 'Vas a hacer un pedido con esta dirección de correo electrónico',
    'You are shipping in a foreign country': 'Vas a efectuar el envío a un país extranjero',
    'Your available points': 'Tus puntos disponibles',
    'Your avalaible bonus': 'Saldo Bonus disponible',
    'Zip code': 'Código postal',
    'Zip or city': 'Código postal o ciudad',
    'zipdigitwarnings': 'Warning the zip code should consist of {zipdigits} charachters',
    'Shipping cost excluded': 'Gastos de envío excluidos',
    'Extra address': 'Información adicional: (opcional)',
    'Extra address placeholder': 'c/o, extensión, fracción, nombre en el interfono',
    '8 characters': '8 caracteres',
    '1 lowercase letter': '1 letra minúscula',
    '1 uppercase letter': '1 letra mayúscula',
    '1 number': '1 número',
    '1 special character': '1 caracter especial',
    'Now you can use your points': 'Ahora puedes usar tus puntos',
    'Hallo': 'Hola',
    'Save Credit Card (One Click Payment)': 'Guardar tarjeta de crédito (pago con un clic)',
    'Pay with a saved credit card': 'Pagar con una tarjeta de crédito guardada',
    'Pay with a new credit or debit card': 'Pagar con una nueva tarjeta de crédito o débito',
    'Expiration': 'Caducidad',
    'Other': 'Otro',
    'Applied discounts': 'Descuentos aplicados',
    'Choose size': 'Elegir tamaño',
    'Municipality': 'Municipio',
    'amount-for-freeshipping': 'Le faltan {amount} para conseguir el envío gratuito por mensajería',
    'To proceed you must select a payment method': 'Para continuar debe seleccionar un método de pago',
    'To proceed you need to save the selected billing address': 'Para continuar es necesario guardar la dirección de facturación seleccionada',
    'To proceed it is necessary to accept the general conditions of sale': 'Para continuar es necesario aceptar las condiciones generales de venta',
    'To proceed you need to select the store': 'Para continuar debe seleccionar la tienda',
    'To proceed you need to save your changes': 'Para continuar debe guardar los cambios',
    'Are you sure you want to delete this address?': '¿Está seguro de que desea eliminar esta dirección?',
    'To proceed you need to save the selected shipping address': 'Para continuar es necesario guardar la dirección de envío seleccionada',
    'message-double_optin_using_point_disabled': 'No puede canjear puntos por esta compra, ya que aún no ha confirmado la validez de su correo electrónico o número de teléfono. Si tiene alguna duda, póngase en contacto con nuestro servicio de atención al cliente.',
}

export default es;
export const esValidation = {
    name: "es",
    messages: {
        _default: function (e: any) {
            return "El valor del campo " + e + " no es válido."
        },
        after: function (e: any, n: any) {
            return "El " + e + " debe ser posterior a " + n[0] + "."
        },
        alpha: function (e: any) {
            return "El campo " + e + " solo puede contener caracteres alfabéticos."
        },
        alpha_dash: function (e: any) {
            return "El campo " + e + " puede contener caracteres alfanuméricos, así como guiones y rayas de subrayado."
        },
        alpha_num: function (e: any) {
            return "El campo " + e + " solo puede contener caracteres alfanuméricos."
        },
        alpha_spaces: function (e: any) {
            return "El campo " + e + " solo puede contener caracteres alfanuméricos y espacios."
        },
        before: function (e: any, n: any) {
            return "El campo " + e + " debe ser anterior a " + n[0] + "."
        },
        between: function (e: any, n: any) {
            return "El campo " + e + " debe estar comprendido entre " + n[0] + " y " + n[1] + "."
        },
        confirmed: function (e: any, n: any) {
            return "El campo " + e + " no corresponde con " + n[0] + "."
        },
        credit_card: function (e: any) {
            return "El campo " + e + " no es válido."
        },
        date_between: function (e: any, n: any) {
            return "La " + e + " debe estar comprendida entre " + n[0] + " e " + n[1] + "."
        },
        date_format: function (e: any, n: any) {
            return "La " + e + " debe tener el formato " + n[0] + "."
        },
        decimal: function (e: any, n: any) {
            void 0 === n && (n = []);
            var r = n[0];
            return void 0 === r && (r = "*"), "Il campo " + e + " debe ser numérico y puede contener" + (r && "*" !== r ? " " + r : "") + " puntos decimales."
        },
        digits: function (e: any, n: any) {
            return "El campo " + e + " debe ser numérico y contener exactamente " + n[0] + " cifre."
        },
        dimensions: function (e: any, n: any) {
            return "El campo " + e + " debe ser " + n[0] + " x " + n[1] + "."
        },
        email: function (e: any) {
            return "El campo " + e + " debe ser una dirección de correo electrónico válida."
        },
        excluded: function (e: any) {
            return "El campo " + e + " debe tener un valor válido."
        },
        ext: function (e: any) {
            return "El campo " + e + " debe ser un archivo válido."
        },
        image: function (e: any) {
            return "El campo " + e + " debe ser una imagen."
        },
        included: function (e: any) {
            return "El campo " + e + " debe tener un valor válido."
        },
        ip: function (e: any) {
            return "El campo " + e + " debe ser una dirección IP válida."
        },
        length: function (e: any, n: any) {
            return "La longitud del campo " + e + " debe ser de " + n[0] + "."
        },
        max: function (e: any, n: any) {
            return "El campo " + e + " no puede tener más de " + n[0] + " caracteres."
        },
        max_value: function (e: any, n: any) {
            return "El campo " + e + " debe ser menor o igual que " + n[0]
        },
        mimes: function (e: any) {
            return "El campo " + e + " debe tener un tipo de archivo válido."
        },
        min: function (e: any, n: any) {
            return "El campo " + e + " debe tener al menos " + n[0] + " caracteres."
        },
        min_value: function (e: any, n: any) {
            return "El campo " + e + " debe ser mayor o igual que " + n[0]
        },
        numeric: function (e: any) {
            return "El campo " + e + " solo puede contener caracteres numéricos."
        },
        regex: function (e: any) {
            return "El campo " + e + " no tiene un formato válido."
        },
        required: function (e: any) {
            return "El campo " + e + " es necesario."
        },
        size: function (e: any, n: any) {
            return "El campo " + e + " debe ser menor que " + function (e) {
                const n = 1024;
                const r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / Math.pow(n, r)).toFixed(2));
                const v = 1 * f;
                return v.toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r]
            }(n[0]) + "."
        },
        url: function (e: any) {
            return "El campo " + e + " no es una URL válida."
        },
        'validate-piva-cf': function (e: any) {
            return 'Número de IVA / código fiscal no válido.';
        },
        'validate-regionid': function (e: any) {
            return 'El campo Provincia es necesario.';
        },
        'validate-ascii': function(e: any) {
            return 'This field cannot contains special charachters';
        },
        'validate-streetandnumber': function(e: any, n: any) {
            return 'Street and street number fields must not exceed {2} charachters';
        },
        'validate-data-consensus': function(e: any) {
          return 'Se requiere su consentimiento para el procesamiento de datos personales.';
        },
        'validate-gender': function(e: any) {
            return 'El campo Sexo es obligatorio.';
        },
        'validate-password': function(e: any) {
            return 'La contraseña debe tener al menos 8 caracteres y una letra mayúscula, una minúscula, un número y un carácter especial (.;,!$#).';
        },
    },
    attributes: {}
};
